import {
  Configuration,
  PopupRequest,
  //ServerResponseType,
} from "@azure/msal-browser";

// Config object to be passed to Msal on creation
export const msalConfig: Configuration = {
  auth: {
    clientId: "44548faa-8453-43c3-bf7d-9e28313d8d26",
    authority:
      "https://login.microsoftonline.com/bc07d099-091f-4ef3-aa8f-7bdf279319fb",
    //redirectUri: "https://spaoauth.synbonitatest.az.synchro.ar",

    redirectUri: "https://synbonitauat.az.synchro.ar/home",

    //postLogoutRedirectUri: "https://spaoauth.synbonitatest.az.synchro.ar",
    postLogoutRedirectUri: "https://synbonitauat.az.synchro.ar/login",
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    allowNativeBroker: false, // Disables WAM Broker
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        {
          /*      switch (level) {
          case msal.LogLevel.Error:
            console.error(message);
            return;
          case msal.LogLevel.Info:
            console.info(message);
            return;
          case msal.LogLevel.Verbose:
            console.debug(message);
            return;
          case msal.LogLevel.Warning:
            console.warn(message);
            return;
        }*/
        }
      },
    },
  },
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest: PopupRequest = {
  scopes: ["User.Read", "Mail.Read"],
};

//const tokenRequest = {
//  scopes: ["User.Read", "Mail.Read"],
//  forceRefresh: false, // Set this to "true" to skip a cached token and go to the //server to get a new token
//};
// Add here the endpoints for MS Graph API services you would like to use.
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
  graphMailEndpoint: "https://graph.microsoft.com/v1.0/me/messages",
};
